import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { ChatMessage } from '../chat/Chat'
import { User } from '../user/User'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('TaskConversationInput')
export class TaskConversation {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('tcon') })
  _id: string

  @Field(() => User)
  @Prop({ type: User })
  sender: User

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => String)
  @Prop({ type: String })
  subject: string

  @Field(() => [ChatMessage])
  @Prop({ type: [ChatMessage] })
  chatMessages: ChatMessage[]
}
